import React, { useContext, useEffect, useState } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function ErrorMessage(props) {
  const {
    errors,
  } = useContext(ConfiguratorContext)

  const [visible, setVisible] = useState(typeof errors[props.field] !== 'string' || errors[props.field].length < 1)

  useEffect(() => {
    const newVisible = typeof errors[props.field] !== 'string' || errors[props.field].length < 1
    setVisible(newVisible)

    if (!newVisible && props.scrollToTop !== undefined && props.scrollToTop) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  }, [errors])

  if (visible) return null

  return <div className='validation-error'>{errors[props.field]}</div>
}
